export { LightTabs } from './LightTabs';
